import IService from '../IService';

export default IService.extend({
  postVideosBatch: function (postData) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.renderApiUrl('/api/v1/videos/batch'),
        type: 'POST',
        data: JSON.stringify(postData),
        contentType: 'application/json',
        dataType: 'json',
        error: function (xhr) {
          if (xhr.status === 401) {
            reject({ loggedOut: true });
          } else {
            reject();
          }
        },
        success: function (response) {
          if (response && response.batchId) {
            resolve(response);
          } else {
            reject(response);
          }
        },
      });
    });
  },

  videoLinkedFields: function (videoId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.renderApiUrl('/renderTask/videoLinkedFields'),
        type: 'GET',
        data: { videoId },
        contentType: 'application/json',
        dataType: 'json',
        error: function (xhr) {
          if (xhr.status === 401) {
            reject({ loggedOut: true });
          } else {
            reject();
          }
        },
        success: function (response) {
          if (
            (!response.assetLinkedFields && !response.overlayLinkedFields) ||
            (!response.assetLinkedFields.length &&
              !response.overlayLinkedFields.length)
          ) {
            reject({ noFields: true });
          } else {
            resolve(response);
          }
        },
      });
    });
  },

  videoByTemplate: function (data) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.renderApiUrl('/renderTask/videoByTemplate'),
        type: 'POST',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        error: function (xhr) {
          if (xhr.status === 401) {
            reject({ loggedOut: true });
          } else {
            reject();
          }
        },

        success: function (response) {
          resolve(response);
        },
      });
    });
  },
});
